import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { AdminHeader } from '../AdminHeader/AdminHeader';
import FetchLoading from '../../Loading/FetchLoading';
import { createMRTColumnHelper } from 'material-react-table';
import CummonTable from '../../Common/CummonTable';
import commaNumber from 'comma-number';
import { format } from 'date-fns';

const AgentDeposit = () => {
  const location = useLocation();
  const uid = location?.state;
  const [isLoading, setIsLoading] = useState(false);
  const [depositData, setDepositData] = useState([]);
  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor('depositId', {
      header: 'Deposit Id',
      Cell: ({ row }) => (
        <button
          style={{
            background: 'gray',
            borderRadius: '5px',
            padding: '2px 10px',
            width: '120px',
            cursor: 'pointer',
            border: 'none',
            color: 'var(--white)',
          }}
        >
          {row.original.depositId}
        </button>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
    columnHelper.accessor('sender', {
      header: 'Sender',
      size: '10px',
    }),
    columnHelper.accessor('amount', {
      header: 'Amount',
      Cell: ({ row }) => `${commaNumber(row.original.amount) + ' AED' || '0'}`,
    }),
    columnHelper.accessor('created_at', {
      header: 'Time',
      size: 20,
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
    columnHelper.accessor('attachment', {
      header: 'View',
      size: 20,
      Cell: ({ row }) => (
        <a
          href={row.original?.attachment}
          target="_blank"
          rel="noreferrer"
          style={{ color: 'black' }}
        >
          <Box sx={{ fontSize: 14 }}>View</Box>
        </a>
      ),
    }),
    columnHelper.accessor('remarks', {
      header: 'Remarks',
      size: 20,
      Cell: ({ row }) =>
        `${row.original?.remarks === '' ? 'N/A' : row.original?.remarks}`,
    }),
  ];

  useEffect(() => {
    const fetchQueuesData = () => {
      setIsLoading(true);

      fetch(`https://api-b2b.fasttracktourism.com/agent/deposit/${uid}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          setDepositData(data);
        })
        .catch((error) => console.error('Error fetching data:', error))
        .finally(() => setIsLoading(false));
    };

    fetchQueuesData();
  }, [uid]);

  return (
    <div>
      <AdminHeader />
      <Box px={2}>
        <Typography
          sx={{
            mb: 1,
            color: 'var(--secondary-color)',
            fontSize: '24px',
            fontWeight: '500',
          }}
        >
          Agent Deposit
        </Typography>

        <Box>
          {!isLoading ? (
            <CummonTable data={depositData} columns={columns} pageSize={15} />
          ) : (
            <FetchLoading />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default AgentDeposit;
